import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Car, Flame, Wrench } from 'lucide-react';
import ModelThumb from './ModelThumb';
import { useT } from '../services/i18n';
import { productsAPI, uploadsAPI } from '../services/api';

// Home: the 12 most consulted vehicle models (views + selections + garage + orders), with model photo zoom
const HomeTopModels = () => {
  const { t } = useT();
  const [models, setModels] = useState(null);
  useEffect(() => {
    productsAPI.topModels(12).then((d) => setModels(d.models || [])).catch(() => setModels([]));
  }, []);
  if (!models?.length) return null;
  const gallery = models.filter((m) => m.image).map((m) => ({ src: m.image, alt: `${m.brand} ${m.model}`, url: `${window.location.origin}${m.path}` }));
  return (
    <section className="py-6 sm:py-10 bg-gray-50 border-t border-gray-100" data-testid="home-top-models">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between gap-3 mb-5">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2"><Flame size={22} className="text-orange-500" /> {t('home.topModels')}</h2>
          <Link to="/vehicules" data-testid="home-top-models-all" className="text-sm font-medium text-orange-600 hover:underline whitespace-nowrap">{t('home.topModelsAll')}</Link>
        </div>
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {models.map((m, i) => (
            <li key={m.path} className="group bg-white rounded-xl border border-gray-200 hover:border-orange-400 hover:shadow-md transition-all flex flex-col" data-testid={`home-top-model-${i}`}>
              <div className="w-full aspect-square max-h-[140px] flex items-center justify-center p-3 pb-1">
                {m.image ? <ModelThumb src={m.image} alt={`${m.brand} ${m.model}`} size={120} testId={`home-top-model-image-${i}`} className="group-hover:scale-105" gallery={gallery} shareUrl={`${window.location.origin}${m.path}`} />
                  : m.logo ? <img src={uploadsAPI.resolveUrl(m.logo)} alt={m.brand} loading="lazy" className="no-placeholder w-14 h-14 object-contain opacity-40 grayscale" />
                  : <Car size={40} className="text-gray-200" />}
              </div>
              <Link to={m.path} data-testid={`home-top-model-link-${i}`} className="flex-1 flex flex-col items-center text-center px-3 pb-3">
                <span className="text-[11px] uppercase tracking-wide text-gray-500">{m.brand}</span>
                <span className="text-sm font-semibold text-gray-900 leading-tight line-clamp-2 group-hover:text-orange-700">{m.model}</span>
                <span className="mt-2 inline-flex items-center gap-1 text-[11px] font-medium text-white bg-[#1e3a5f] group-hover:bg-orange-500 px-2 py-1 rounded-full transition-colors"><Wrench size={10} /> {t('home.topModelsParts')}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HomeTopModels;
